import {InputAdornment, TextField} from "@mui/material";
import {country_code} from "@/utils/constants";
import {useState, useEffect, useRef} from "react";
import CommonClass from "@/utils/common";
import {useTranslation} from "react-i18next";
import {textfield_sx} from "@/utils/mui_sx.ts";


interface Props {
    setNumberState?(x:string):void
    disabled?:boolean
    error?:boolean
    defaultValue?:string
    onChange?(e:any):void
    onFocus?():void
    onBlur?():void
    name?:string
}

const PhoneNumberInput= (props: Props)=> {
    const {
        setNumberState,
        disabled,
        error,
        defaultValue,
        onChange,
        onFocus,
        onBlur,
        name
    } = props
    
    const {t} = useTranslation()
    const [phoneNumber, setPhoneNumber] = useState('');
    const ref = useRef<any>(null)
    
    const handlePhoneNumberChange = (event:any) => {
        let formattedNumber = CommonClass.formatNumber(event.target.value)
        setPhoneNumber(formattedNumber);
        
        if(typeof setNumberState === "function"){
            setNumberState(formattedNumber)
        }
        
    };
    
    useEffect(() => {
        if(defaultValue?.length && defaultValue) {
            setPhoneNumber(defaultValue)
        }
    }, [defaultValue]);
    
    useEffect(() => {
        if(ref?.current) {
            ref.current.focus()
        }
    }, []);
    
    
    return (
        <TextField
            error={error}
            ref={ref}
            label={t("phone")}
            onInput={(e:any) => {
                let val = e.target.value;
                if (val.includes(country_code)) {
                    setPhoneNumber(val.replace(country_code, ""));
                    e.target.value = val.replace(country_code, "");
                }
            }}
            placeholder={"000 00 000"}
            name={name || "phone"}
            color="success"
            type="tel"
            value={phoneNumber}
            onChange={(e) => {
                handlePhoneNumberChange(e)
                
                if(typeof onChange === "function"){
                    onChange(e)
                }
            }}
            disabled={disabled}
            InputProps={{
                startAdornment: <InputAdornment position="start">{country_code}</InputAdornment>,
            }}
            sx={{
                ...textfield_sx,
                ...{
                    '& .MuiInputBase-input': {
                        backgroundColor: "transparent !important",
                        
                        '&:-webkit-autofill': {
                            WebkitBoxShadow: `0 0 0 100px ${ location.pathname.includes("login")? "#eceeec" : "white"} inset`,
                            color: "black"
                        },
                    }
                }
            }}
            onBlur={() => {
                if(typeof onBlur == "function") {
                    onBlur()
                }
            }}
            onFocus={() => {
                if(typeof onFocus == "function") {
                    onFocus()
                }
            }}
        />
    )
}

export default PhoneNumberInput